import type { DocumentType } from './types';

export const DOCUMENT_TYPES: DocumentType[] = [
  {
    id: 'privacy-policy',
    title: 'سياسة الخصوصية',
    description: 'حماية بيانات المستخدمين وتوضيح كيفية جمعها واستخدامها.',
    iconName: 'Shield',
  },
  {
    id: 'terms-conditions',
    title: 'الشروط والأحكام',
    description: 'تحديد القواعد والإرشادات لاستخدام موقعك أو خدمتك.',
    iconName: 'FileText',
  },
  {
    id: 'return-exchange',
    title: 'سياسة الاسترجاع والاستبدال',
    description: 'توضيح إجراءات وشروط إرجاع أو استبدال المنتجات.',
    iconName: 'RefreshCw',
  },
  {
    id: 'about-us',
    title: 'من نحن',
    description: 'صفحة تعريفية عن نشاطك التجاري، رؤيتك، ورسالتك.',
    iconName: 'Users',
  },
  {
    id: 'usage-policy',
    title: 'سياسة الإستخدام',
    description: 'وثيقة تحدد القواعد والشروط التي يجب على المستخدمين الالتزام بها عند استخدام الموقع.',
    iconName: 'File',
  },
  {
    id: 'shipping-delivery',
    title: 'سياسة الشحن والتوصيل',
    description: 'معلومات حول طرق الشحن، التكاليف، وأوقات التسليم.',
    iconName: 'Truck',
  },
  {
    id: 'payment-policy',
    title: 'سياسة الدفع',
    description: 'تحديد طرق الدفع المقبولة والشروط المتعلقة بها.',
    iconName: 'CreditCard',
  },
  {
    id: 'cookie-policy',
    title: 'سياسة ملفات تعريف الارتباط',
    description: 'شرح كيفية استخدام ملفات تعريف الارتباط على موقعك.',
    iconName: 'Cookie',
  },
  {
    id: 'acceptable-use',
    title: 'سياسة الاستخدام المقبول',
    description: 'تحديد السلوكيات المسموح بها والمحظورة على موقعك.',
    iconName: 'CheckSquare',
  },
  {
    id: 'disclaimer',
    title: 'سياسة إخلاء المسؤولية',
    description: 'تحديد حدود مسؤوليتك القانونية تجاه المستخدمين.',
    iconName: 'AlertTriangle',
  },
  {
    id: 'eula',
    title: 'اتفاقية ترخيص المستخدم النهائي',
    description: 'شروط استخدام البرامج أو التطبيقات التي تقدمها.',
    iconName: 'FileKey',
  },
  {
    id: 'security-privacy',
    title: 'سياسة الأمان والخصوصية',
    description: 'شرح الإجراءات المتبعة لحماية بيانات المستخدمين.',
    iconName: 'Lock',
  },
  {
    id: 'antispam',
    title: 'سياسة عدم الإزعاج',
    description: 'التزامك بعدم إرسال رسائل غير مرغوب فيها للمستخدمين.',
    iconName: 'Ban',
  },
  {
    id: 'digital-refund',
    title: 'سياسة استرداد المنتجات الرقمية',
    description: 'شروط وإجراءات استرداد الأموال للمنتجات الرقمية.',
    iconName: 'Undo',
  },
  {
    id: 'gdpr-privacy',
    title: 'سياسة الخصوصية وفق GDPR',
    description: 'سياسة خصوصية متوافقة مع اللائحة العامة لحماية البيانات.',
    iconName: 'Eye',
  },
  {
    id: 'cookie-usage',
    title: 'سياسة استخدام ملفات تعريف الارتباط',
    description: 'تفصيل أنواع ملفات تعريف الارتباط المستخدمة والغرض منها.',
    iconName: 'Cookie',
  },
  {
    id: 'blog-comments',
    title: 'سياسة التعليقات على المدونة',
    description: 'قواعد وإرشادات لنشر التعليقات على مدونتك.',
    iconName: 'MessageSquare',
  },
  {
    id: 'testimonials-disclosure',
    title: 'إفصاح الشهادات والتوصيات',
    description: 'توضيح العلاقة بينك وبين مقدمي الشهادات والتوصيات.',
    iconName: 'Award',
  },
  {
    id: 'advertising-disclosure',
    title: 'إفصاح الإعلانات',
    description: 'الإفصاح عن استخدام الإعلانات وكيفية تأثيرها على المحتوى.',
    iconName: 'Megaphone',
  },
  {
    id: 'confidentiality-agreement',
    title: 'اتفاقية السرية',
    description: 'اتفاقية للحفاظ على سرية المعلومات المتبادلة.',
    iconName: 'Lock',
  },
  {
    id: 'newsletter-agreement',
    title: 'اتفاقية الاشتراك في النشرة البريدية',
    description: 'الشروط المتعلقة بالاشتراك في قائمتك البريدية.',
    iconName: 'Mail',
  },
];